import Icon from '@ant-design/icons'

const PlaceSVG = () => (
    <svg
        t='1762390435198'
        class='icon'
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        p-id='11715'
        width='200'
        height='200'
    >
        <path
            d='M646.4 608H377.6c-12.8 0-25.6 12.8-25.6 25.6v76.8c0 12.8 12.8 25.6 25.6 25.6h268.8c12.8 0 25.6-12.8 25.6-25.6V633.6c0-12.8-12.8-25.6-25.6-25.6z'
            fill='currentColor'
            p-id='11716'
        ></path>
        <path
            d='M896 128h-96V25.6c0-12.8-12.8-25.6-25.6-25.6h-76.8c-12.8 0-25.6 12.8-25.6 25.6V128h-320V25.6c0-12.8-12.8-25.6-25.6-25.6H249.6c-12.8 0-25.6 12.8-25.6 25.6V128H128C57.6 128 0 185.6 0 256v640c0 70.4 57.6 128 128 128h768c70.4 0 128-57.6 128-128V256c0-70.4-57.6-128-128-128z m0 128v64h-96V256H896z m-224 0v64h-320V256h320z m-448 0v64H128V256h96zM128 896V448h768v448H128z'
            fill='currentColor'
            p-id='11717'
        ></path>
    </svg>
)

export const PlanIcon = props => <Icon component={PlaceSVG} {...props} />
